// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1PasswordUpdateSchema } from './v1/password/updateSchema';

export const updateUserPasswordHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string().describe("Bearer token")),
});

/**
 * @description password updated successfully
 */
export const updateUserPassword200Schema = z.object({
  notice: z.optional(z.object({
    message: z.optional(z.coerce.string()),
  })),
  status: z.optional(z.coerce.string()),
});

/**
 * @description unauthorized
 */
export const updateUserPassword401Schema = z.unknown();

/**
 * @description validation errors
 */
export const updateUserPassword422Schema = z.object({
  errors: z.optional(z.object({})),
});

export const updateUserPasswordMutationRequestSchema = z.lazy(() => v1PasswordUpdateSchema);

export const updateUserPasswordMutationResponseSchema = z.lazy(() => updateUserPassword200Schema);
